export default {"src":"/europe/spain/_next/static/media/pag-prev.f55dc3aa.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};